exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2CJEGHRctuZJ_X_1oiUMVC {\n  font-size: 24px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n._2SQ5_XPd8EC_ReBFD-JCBS {\n  font-size: 14px;\n  margin-bottom: 40px;\n}\n", ""]);

// Exports
exports.locals = {
	"title": "_2CJEGHRctuZJ_X_1oiUMVC",
	"description": "_2SQ5_XPd8EC_ReBFD-JCBS"
};